/**
 * Health Nexus care-team access list for a patient.
 *
 * The list combines the plan's doctor/coordinator/nurse (source: 'plan',
 * computed server-side and not removable) with any extra staff added on top
 * (source: 'manual'). Only manual people can be added/removed here.
 *
 * `role` is already the account's own label for that role type (Admin -> Roles),
 * resolved server-side — never render a hardcoded Physician/ECC/Provider here.
 */
import { apiClient } from '@/services/apiClient';
import type { ApiResponse } from '@/types/api.types';

export type HealthNexusAccessSource = 'plan' | 'manual';

export interface HealthNexusAccessEntry {
  userId: number;
  name: string;
  role: string;
  source: HealthNexusAccessSource;
}

export function getHealthNexusAccess(patientId: number): Promise<HealthNexusAccessEntry[]> {
  return apiClient
    .get<ApiResponse<HealthNexusAccessEntry[]>>(`/patients/${patientId}/health-nexus-access`)
    .then((r) => r.data.data ?? []);
}

export function addHealthNexusAccess(patientId: number, userId: number): Promise<void> {
  return apiClient
    .post(`/patients/${patientId}/health-nexus-access`, { userId })
    .then(() => undefined);
}

export function removeHealthNexusAccess(patientId: number, userId: number): Promise<void> {
  return apiClient
    .delete(`/patients/${patientId}/health-nexus-access/${userId}`)
    .then(() => undefined);
}
